<template>
  <div class="scroll_bar overflow-scroll">
    <div class="bg-white sticky top-0 mb-4 z-80 border-b-2 border-gray-700 pt-6 pb-3 px-4">
      <div class="text-center mb-5 text-xl font-semibold font-sf-pro">
        Выберете дату
      </div>
      <div class="grid grid-cols-7 gap-1">
        <div
          v-for="(day, index) in days"
          :key="index"
          class="flex font-sf-pro text-xs uppercase items-center justify-center"
          :class="{ 'text-decorative-scarlet': index === 6 || index === 5 }"
        >
          {{ day }}
        </div>
      </div>
    </div>

    <div class=" relative z-10">
      <div
        v-for="data in listMonth"
        :key="data.month"
      >
        <t-full-calendar-month :year="data.year" :month="data.month" :active-date="activeDate" @select-date="onSelectDate" />
      </div>
    </div>
  </div>
</template>

<script setup>
const days = reactive(['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'])

const emit = defineEmits(['select-date'])

const activeDate = ref('')

function onSelectDate (value) {
  activeDate.value = value
  emit('select-date', value)
}

const listMonth = computed(() => {
  const today = new Date()
  const currentMonth = today.getMonth()
  const currentYear = today.getFullYear()
  const nextYear = new Date(new Date(today).setFullYear(new Date(today).getFullYear() + 1))

  const data = []
  for (let i = currentMonth; i < 12; i++) {
    data.push({
      year: currentYear,
      month: i + 1
    })
  }

  for (let i = 0; i < currentMonth; i++) {
    data.push({
      year: nextYear.getFullYear(),
      month: i + 1
    })
  }

  return data
})
</script>

<style scoped>
.scroll_bar::-webkit-scrollbar {
  display: none;
}

/* Скрываем scrollbar для IE, Edge и Firefox */
.scroll_bar {
  -ms-overflow-style: none; /* IE и Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
